import instance from "./index";

export const getAllConversations = async () => {
  return await instance.get("/conversations");
};

export const getConversationBySilosId = async (silosId) => {
  return await instance.get(`/conversation/getConversationBySilosId/${silosId}`);
};

export const getConversation = async (
  silosId,
  { isGlobal = true, clientId, projectId } = {},
) => {
  const params = { isGlobal: isGlobal ? "true" : "false" };
  if (clientId != null && clientId !== "") {
    params.clientId = clientId;
  }
  if (projectId != null && projectId !== "") {
    params.projectId = projectId;
  }
  return await instance.get(`/conversation/getConversation/${silosId}`, {
    params,
  });
};

export const getLatestConversation = async (silosId) => {
  return await instance.get(`/conversation/getLatestConversation/${silosId}`);
};

export const getConversationByClientId = async (clientId, silosId, projectId) => {
  const config = {};
  if (projectId != null && projectId !== "") {
    config.params = { projectId };
  }
  return await instance.get(
    `/conversation/getConversationByClientId/${clientId}/${silosId}`,
    config,
  );
}; 

export const getConversationByUserId = async (siloId) => {
  return await instance.get(`/conversation/getConversationByUserId/${siloId}`);
};

export const deleteConversationById = async (conversationId) => {
  return await instance.delete(`/conversation/${conversationId}`);
};


export const getConversationByClientIdAndProjectId = async (clientId, projectId) => {
  return await instance.get(`/conversation/getConversationByClientIdAndProjectId/${clientId}/${projectId}`);
};

const isFileLike = (value) =>
  typeof Blob !== "undefined" && value != null && value instanceof Blob;

export const updateConversation = async (conversationId, payload = {}) => {
  const url = `/conversation/update/${conversationId}`;

  if (payload instanceof FormData) {
    return await instance.put(url, payload);
  }

  const data =
    payload && typeof payload === "object" && !Array.isArray(payload)
      ? payload
      : {};
  const entries = Object.entries(data).filter(([, v]) => v !== undefined);
  const hasFile = entries.some(([, v]) => isFileLike(v));

  if (!hasFile) {
    return await instance.put(url, data);
  }

  const formData = new FormData();
  for (const [key, value] of entries) {
    if (value === null) continue;
    if (isFileLike(value)) {
      const name =
        typeof File !== "undefined" && value instanceof File && value.name
          ? value.name
          : "image";
      formData.append(key, value, name);
      continue;
    }
    if (typeof value === "boolean") {
      formData.append(key, value ? "true" : "false");
      continue;
    }
    if (typeof value === "number") {
      formData.append(key, String(value));
      continue;
    }
    if (typeof value === "object") {
      formData.append(key, JSON.stringify(value));
      continue;
    }
    formData.append(key, String(value));
  }

  return await instance.put(url, formData);
};

export const buildConversationStatusUpdatePayload = (session, newTitle, opts = {}) => {
  const { globallyAvailable = true } = opts;

  const archivedRaw =
    session?.isArchived ?? session?.IsArchived ?? session?.is_archived;
  const isArchived =
    archivedRaw === undefined || archivedRaw === null
      ? false
      : Boolean(archivedRaw);

  const title = String(newTitle ?? "").trim();

  const body = {
    title,
    isArchived,
    globallyAvailable: Boolean(globallyAvailable),
  };

  return { body };
};
